module.exports = __webpack_public_path__ + "img/Ivory-Coast.0a3a63d3.png";